import { Stepper, styled } from "@mui/material";

const StepperComponentStyled = styled(Stepper)({
    "& .MuiStepIcon-root": {
        border: "1px solid #405289",
        borderRadius: "50%",
        color: "#fff",
    },
    "& .MuiStepIcon-root.Mui-active": {
        color: "#405289",
        border: 0,
        fontSize: "26px",
    },
    "& .MuiStepIcon-root.Mui-completed": {
        color: "#405289",
        border: 0,
        fontSize: "26px",
    },
    "& .MuiStepIcon-text": {
        fill: "#586A84",
        fontWeight: "500",
        fontSize: "14px",
        lineHeight: "16px",
    },
    "& .MuiStepIcon-root.Mui-active .MuiStepIcon-text": {
        fill: "#fff",
    },
    "& .MuiStepConnector-line": {
        borderColor: "#405289",
        borderTopStyle: "dotted",
        borderTopWidth: "3px",
    },
});

export default StepperComponentStyled;
